// Utilities for the booking calendar (Europe/London).
export const MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
export const DOW = ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'];

export function londonNow() {
  // Build a Date representing the current instant, but we’ll format via toLocaleString when needed.
  return new Date();
}

// Return YYYY-MM-DD for a given date-in-london view (using year/month/day fields directly).
export function isoDate(y, m /* 0-indexed */, d) {
  const mm = String(m + 1).padStart(2, '0');
  const dd = String(d).padStart(2, '0');
  return `${y}-${mm}-${dd}`;
}

// Days in month (m 0-indexed)
export function daysInMonth(y, m) {
  return new Date(y, m + 1, 0).getDate();
}

// Return 0-6 index (Mon=0 ... Sun=6) for the 1st of month.
export function firstDayIndex(y, m) {
  const d = new Date(y, m, 1).getDay(); // 0=Sun..6=Sat
  return (d + 6) % 7; // shift so Monday=0
}

// Return {y,m,d} for London-current date.
export function londonToday() {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/London',
    year: 'numeric', month: '2-digit', day: '2-digit'
  }).formatToParts(new Date());
  const y = Number(parts.find(p => p.type === 'year').value);
  const m = Number(parts.find(p => p.type === 'month').value) - 1;
  const d = Number(parts.find(p => p.type === 'day').value);
  return { y, m, d };
}

// Whether the given YYYY-MM-DD is entirely within the 24-hour notice window
// (i.e. every slot on that date would be < 24h from now).
export function dateFullyInsideNoticeWindow(dateStr) {
  // The latest slot on the date is 17:30 London. If that instant is < now + 24h, the whole day is blocked.
  const [y, m, d] = dateStr.split('-').map(Number);
  // 17:30 London → convert by constructing a fake ISO and using Intl offset approach.
  // Simplest: build a Date assuming BST/GMT via Intl.
  const testUtc = londonLocalToUtc(y, m - 1, d, 17, 30);
  return testUtc.getTime() < Date.now() + 24 * 60 * 60 * 1000;
}

// Convert a London wall-clock date/time to a UTC Date instance.
export function londonLocalToUtc(y, m, d, hh, mm) {
  // Trick: build a date labelled as London using formatToParts.
  const guess = new Date(Date.UTC(y, m, d, hh, mm));
  const asLondon = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/London', hour12: false,
    year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit'
  }).formatToParts(guess).reduce((acc,p)=>{acc[p.type]=p.value; return acc;}, {});
  const londonY = Number(asLondon.year);
  const londonMo = Number(asLondon.month);
  const londonD = Number(asLondon.day);
  const londonH = Number(asLondon.hour);
  const londonMi = Number(asLondon.minute);
  const targetUtcMs = Date.UTC(y, m, d, hh, mm);
  const displayedUtcMs = Date.UTC(londonY, londonMo - 1, londonD, londonH, londonMi);
  const offsetMs = displayedUtcMs - guess.getTime();
  return new Date(targetUtcMs - offsetMs);
}

export function isPastDate(dateStr) {
  const { y, m, d } = londonToday();
  const [dy, dm, dd] = dateStr.split('-').map(Number);
  const today = new Date(Date.UTC(y, m, d));
  const target = new Date(Date.UTC(dy, dm - 1, dd));
  return target < today;
}

export function formatLongDate(dateStr) {
  const [y, m, d] = dateStr.split('-').map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d));
  return new Intl.DateTimeFormat('en-GB', { weekday:'long', day:'numeric', month:'long', year:'numeric', timeZone: 'UTC' }).format(dt);
}

export function formatTimeFromIso(iso) {
  return new Intl.DateTimeFormat('en-GB', { hour:'2-digit', minute:'2-digit', hour12:false, timeZone:'Europe/London' }).format(new Date(iso));
}
